import { render } from "./Policy.vue?vue&type=template&id=08822633&scoped=true"
import script from "./Policy.vue?vue&type=script&lang=js"
export * from "./Policy.vue?vue&type=script&lang=js"

import "./Policy.vue?vue&type=style&index=0&id=08822633&scoped=true&lang=css"

import exportComponent from "/Users/admin/Work/MANTEE_HOME/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08822633"]])

export default __exports__